var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CustomSelectComponent',{ref:"select",attrs:{"label":_vm.label,"labelCols":_vm.labelCols,"options":_vm.options,"rules":_vm.rules,"value":_vm.value},on:{"input":(value) => _vm.$emit('input', value),"change":(value) => _vm.$emit('change', value)}})
}
var staticRenderFns = []

export { render, staticRenderFns }